<script lang="ts">
    export let name = "";
    export let title = "";
    export let ariaHidden = true;
    export let extraClass = "";
    export let color: string = 'currentColor';
    export let styleExtra: string = "";
</script>

<i class={`${name} ${extraClass}`} aria-hidden={ariaHidden} {title} style={`color: ${color}; ${styleExtra}`}></i>
